/**
 * Formats amounts in cents to dollars.
 *
 * @param {number} amountInCents
 * @returns {string} - Amount in Dollars
 */
const getFormattedCentsAmount = amountInCents => {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  return numberFormatter.format(Math.abs(amountInCents) / 100);
};

export default getFormattedCentsAmount;
